module.exports = __webpack_public_path__ + "static/media/checkmark-green.0525ca3c.svg";